export type GtmEventName = "gtm.js";

type GtmDataLayerEvent = {
	"gtm.start": number;
	event: GtmEventName;
};

declare global {
	interface Window {
		dataLayer?: unknown[];
	}
}

const CONTAINER_ID_PATTERN = /^GTM-[A-Z0-9]+$/;
const SCRIPT_SELECTOR = "script[data-leabank-gtm]";

let analyticsAllowed = false;
let configuredContainerId: string | undefined;

export const isGtmContainerId = (value: string): boolean =>
	CONTAINER_ID_PATTERN.test(value);

const loadGtm = (containerId: string) => {
	if (
		typeof window === "undefined" ||
		configuredContainerId === containerId
	) {
		return;
	}

	window.dataLayer ??= [];
	window.dataLayer.push({
		"gtm.start": Date.now(),
		event: "gtm.js",
	} satisfies GtmDataLayerEvent);

	if (!document.querySelector(SCRIPT_SELECTOR)) {
		const script = document.createElement("script");
		script.async = true;
		script.dataset.leabankGtm = "true";
		script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
		document.head.append(script);
	}

	configuredContainerId = containerId;
};

export const setGtmAnalyticsConsent = (
	containerId: string | null,
	granted: boolean
): void => {
	analyticsAllowed =
		granted && containerId !== null && isGtmContainerId(containerId);

	if (analyticsAllowed && containerId) {
		loadGtm(containerId);
	}
};
